import { useMemo } from "react";

import { RydeUiUnit, TPermissionAction } from "../models";
import { useHasPermissionsCheck } from "./use-has-permissions-check";

export const useHasPermissions = ({
  entity,
  action,
}: {
  entity?: RydeUiUnit;
  action?: TPermissionAction;
}): { hasPermissions: boolean } => {
  const { hasPermissionsCheck } = useHasPermissionsCheck();

  const hasPermissions = useMemo(() => {
    return hasPermissionsCheck({ action, entity });
  }, [action, entity, hasPermissionsCheck]);

  return { hasPermissions };
};
